import { useMutation } from '@tanstack/react-query';

import type {
  DisableDateData,
  DisableDateResponse,
  DisableWorkDayData,
  DisableWorkDayResponse,
  RefreshDailyScheduleResponse,
  UpdateBookingPeriodData,
  UpdateBookingPeriodResponse,
  UpdateWorkTimeData,
  UpdateWorkTimeResponse,
} from '@/types/api/mutations/bookingProviderWorkTime';

import { HttpClient } from '@/network/HttpClient';

export const useUpdateWorkTimeMutation = () =>
  useMutation({
    mutationFn: (params: {
      companyApiUrl: string;
      locationId: number;
      providerId: number;
      workTimeId: number;
      method: 'POST' | 'PUT';
      data: UpdateWorkTimeData;
    }) =>
      HttpClient.request<UpdateWorkTimeResponse>({
        method: params.method,
        url: `${params.companyApiUrl}/booking_settings/locations/${params.locationId}/booking_providers/${params.providerId}/booking_provider_work_times/${params.workTimeId}`,
        data: {
          booking_provider_work_time: params.data,
        },
      }),
  });

export const useDisableWorkDayMutation = () =>
  useMutation({
    mutationFn: (params: {
      companyApiUrl: string;
      locationId: number;
      providerId: number;
      method: 'POST' | 'PUT';
      data: DisableWorkDayData;
    }) =>
      HttpClient.request<DisableWorkDayResponse>({
        method: params.method,
        url: `${params.companyApiUrl}/booking_settings/locations/${params.locationId}/booking_providers/${params.providerId}/booking_provider_work_times/disable_work_day`,
        data: params.data,
      }),
  });

export const useRefreshDailyScheduleMutation = () =>
  useMutation({
    mutationFn: (params: {
      companyApiUrl: string;
      locationId: number;
      providerId: number;
    }) =>
      HttpClient.request<RefreshDailyScheduleResponse>({
        method: 'PATCH',
        url: `${params.companyApiUrl}/booking_settings/locations/${params.locationId}/booking_providers/${params.providerId}/booking_provider_work_times/refresh_daily_schedule`,
      }),
  });

export const useUpdateBookingPeriodMutation = () =>
  useMutation({
    mutationFn: (params: {
      companyApiUrl: string;
      locationId: number;
      providerId: number;
      periodId: number;
      method: 'POST' | 'PUT';
      data: UpdateBookingPeriodData;
    }) =>
      HttpClient.request<UpdateBookingPeriodResponse>({
        method: params.method,
        url: `${params.companyApiUrl}/booking_settings/locations/${params.locationId}/booking_providers/${params.providerId}/booking_periods/${params.periodId}`,
        data: {
          booking_period: params.data,
        },
      }),
  });

export const useDisableDateMutation = () =>
  useMutation({
    mutationFn: (params: {
      companyApiUrl: string;
      locationId: number;
      providerId: number;
      method: 'POST' | 'PUT';
      data: DisableDateData;
    }) =>
      HttpClient.request<DisableDateResponse>({
        method: params.method,
        url: `${params.companyApiUrl}/booking_settings/locations/${params.locationId}/booking_providers/${params.providerId}/booking_periods/disable_date`,
        data: params.data,
      }),
  });
